import { http } from '@/plugins/http';
import { getCode, getToken, getCookie } from "@/utils";

let userInfo = {
  tenantid: 'cb166d21c11df8b6da277c40e8b1a3d9',
  uid: 1,
  username: 'idaadmin',
  token: '5F07D43600B44A4EBE12014A0AF4019F'
}
export default {
  // 样例1
  resourceStatistics(params) {
    return http({
      method: "get",
      url: "/ermsapi/resource/statistics/public",
      params: params
    })
  },
  // 样例2
  getCatalogs(params) {
    return http({
      method: "get",
      url: "/crmsapi/crms/product/api/getCatalogs",
      params: {
        params,
        ...userInfo
      }
    });
  },
  //样例3
  getResourcesDetail(params) {
    return http({
      method: "post",
      url: "/crmsapi/crms/product/api/getResourceDetail",
      data: {
        params,
        ...userInfo
      }
    });
  },
  getTitle(data) { // 获取网站名字和logo
    return http({
      method: "get",
      // url: "/cmsapi/v1/index-template/get-header-footer",
      url: "/cmsapi/v1/setting/info",
      params: data
    });
  },
  getNav() { // 获取顶部菜单
    return http({
      method: "get",
      url: "/cmcapi/consolev1/menu/group-nav",
      params: {cloud_mode:1,usage: ''}
    });
  },
  getAsideNav(params) { // 获取左侧菜单
    return http({
      method: "get",
      url: "/cmcapi/consolev1/menu/item-nav",
      params: params
    });
  },
  getRealLink(data) {
    return http({
      method: "get",
      url: '/consoleapi/v2/login/wj-module-url',
      params: data
    })
  },
  getGroupUser() { // 获取框架用户信息
    return http({
      method: "get",
      url: '/consoleapi/v2/user/group-user',
    })
  },
  getUserInfo(data) { // 获取用户信息
		return http({
      url: '/eduuserapi/v1/infosimple',
      method: "get",
			params: data,
			headers: {
				'Authorization': `Bearer ${getToken()}`
      }
		})
  },
  //框架垂直鉴权
  loginAuth (params) {
    return http({
      method: 'post',
      url: './eduuserapi/v1/login-auth',
      data: params
    })
  },
  getStatistics(data) { // 数据统计页面
    return http({
      url: '/courseapi/v2/cmc/get-billings',
      method: "get",
      params: data,
      headers: {
				'Authorization': `${getToken()}`
      }
    })
  },
  getRoleInfo(data) { // 获取用户角色
    return http({
      url: '/cmcapi/consolev1/roles/get-product-roles?page=1&page_size=10',
      method: "get",
      params: data
    })
  },
  getRoleMenu(data) { // 获取角色菜单
    return http({
      url: '/cmcapi/consolev1/roles/binding-roles-menus-tree',
      method: "get",
      params: data
    })
  },
  getPermissionTree(data) { // 获取角色菜单
    return http({
      url: '/eduuserapi/v1/back/permission/tree',
      method: "get",
      params: data,
      headers: {
				'Authorization': `Bearer ${getToken()}`
      }
    })
  },
  backPermissionUpdate (params, data) {
    return http({
      url: '/eduuserapi/v1/back/permission/update',
      method: "post",
      params: params,
      data: data,
      headers: {
				'Authorization': `Bearer ${getToken()}`
      }
    })
  },
  roleBackPermission () {
    return http({
      url: '/eduuserapi/v1/user/role/back/permission',
      method: "get",
      headers: {
				'Authorization': `Bearer ${getToken()}`
      }
    })
  },
  setRoleMenu(data) {
    return http({
      url: '/cmcapi/consolev1/roles/update-bind-roles-menus',
      method: "post",
      data: data
    })
  },
  // 同步与框架的产品id
  updateProductId (params) {
    return http({
      url: '/cmcapi/groupv1/login/login-product',
      method: "get",
      params: {
        ...params
      }
    })
  },
  updateUserInfo( id, params ){  // 修改用户
    // return http.put(`/eduuserapi/v1/member/${id}`, params, {
    //   headers: {
    //     Authorization: 'Bearer '+ getToken()
    //   },
    //   method: "put"
    // })
    return http({
      url: `/eduuserapi/v1/member/${id}`,
      data: params,
      headers: {
        Authorization: 'Bearer '+ getToken()
      },
      method: "put"
    })
  },
  updatePassword( id, params ){
    // return http.post(`/eduuserapi/v1/member/changepwd/${id}`, params, {
    //   headers: {
    //     Authorization: 'Bearer '+ getToken()
    //   }
    // })
    return http({
      url:`/eduuserapi/v1/member/changepwd/${id}`,
      method: 'post',
      headers:{
        Authorization: 'Bearer ' + getToken()
      },
      data: params
    })
  },
  getDingCordId (id) {
		return http({
			url: '/tenantapi/v1/tenantwx-field?tenant_id=' + id,
			method: 'get'
		})
	},
  getTerribleColor(data) {
    return http({
      url: '/cmsapi/v1/style-module/get-tenant-use-module',
      method: "get",
      params: data
      // use_web=education&type=header_left&tenant=300
    })
  },
  setAvatar(data) {
    return http({
      method: "post",
      url: '/consoleapi/v2/user/set-user-pic',
      data
    })
  },
}



// WEBPACK FOOTER //
// ./src/api/common/index.js